import { render, staticRenderFns } from "./PageTable.vue?vue&type=template&id=d5634d9c&scoped=true&"
import script from "./PageTable.vue?vue&type=script&lang=ts&"
export * from "./PageTable.vue?vue&type=script&lang=ts&"
import style0 from "./PageTable.vue?vue&type=style&index=0&id=d5634d9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5634d9c",
  null
  
)

export default component.exports